<script lang="ts">
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="30"
  height="32"
  viewBox="0 0 30 32"
  fill="#EBAFEF"
>
  <g filter="url(#filter0_d_1575_2961)">
    <rect x="2.25" y="1.71582" width="2.78906" height="0.996094" />
    <rect x="2.25" y="6.09863" width="10.3594" height="0.996094" />
    <rect x="2.25" y="10.4814" width="17.7305" height="0.996094" />
    <rect x="2.25" y="14.8643" width="25.5" height="0.996094" />
    <rect x="2.25" y="19.2471" width="17.7305" height="0.996094" />
    <rect x="2.25" y="23.6299" width="10.3594" height="0.996094" />
    <rect x="2.25" y="28.0127" width="2.78906" height="0.996094" />
  </g>
  <defs>
    <filter
      id="filter0_d_1575_2961"
      x="0.257812"
      y="0.12207"
      width="29.4844"
      height="31.2773"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.398438" />
      <feGaussianBlur stdDeviation="0.996094" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.582801 0 0 0 0 0.124928 0 0 0 0 0.652646 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_1575_2961"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_1575_2961"
        result="shape"
      />
    </filter>
  </defs>
</svg>

<style>
  svg {
    position: absolute;
    left: -0.8rem;
    top: -0.5rem;
  }
</style>
